import {
    getCreateEquityApiEndpoint,
    getDetailedEquityProductTemplatesEndpoint,
    getEquityCategoryAndBrandsApiEndpoint,
    getEquityProductsByBrandOrSuperCategoryApiEndpoint,
    getProductDetailsApiEndpoint,
    getEquityProductSearchEndpoint,
    getValidatedProductsEndpoint,
    getEquityTemplateDetailsEndpoint,
    createEquityProductTemplateEndpoint,
    updateEquityProductTemplateEndpoint,
    getDataForEquityTemplateEndpoint,
    getPricesForItemsEndpoint,
} from 'src/pages/equity/services/endpoints';
import {} from 'src/pages/equity/services/endpoints';
import axios from 'src/api/Api';
import { getDropdownEnpoint } from './endpoints';
export const saveEquityDataService = async (obj) => {
    const response = await axios.post(getCreateEquityApiEndpoint, obj);
    return response ? response.data : {};
};

export const getEquityCategoryAndBrandsDataService = async (territoryIdValue) => {
    const response = await axios.get(getEquityCategoryAndBrandsApiEndpoint(territoryIdValue));
    return response ? response.data : {};
};

export const getEquityProductsByBrandOrSuperCategoryDataService = async (
    queryParams
) => {
    const response = await axios.get(
        getEquityProductsByBrandOrSuperCategoryApiEndpoint(queryParams)
    );
    return response ? response.data : {};
};

export const getProductsGuideDataService = async () => {
    const response = await axios.get('productsGuide');
    return response ? response.data : {};
};

export const getProductDetailsDataService = async (
    productCFN,
    salesOrg,
    orderType,
    resourceType
) => {
    const response = await axios.get(
        getProductDetailsApiEndpoint(
            productCFN,
            salesOrg,
            orderType,
            resourceType
        )
    );
    return response ? response.data : {};
};

export const getEquityProductSearchDataService = async (queryParams, token) => {
    const response = await axios.get(
        getEquityProductSearchEndpoint(queryParams),
        { cancelToken: token }
    );
    return response ? response.data : {};
};

export const getDetailedEquityProductTemplatesDataService = async (
    queryParams
) => {
    const response = await axios.get(
        getDetailedEquityProductTemplatesEndpoint(queryParams)
    );
    return response ? response.data : {};
};

export const getEquityValidateProductsDataServices = async (queryParams) => {
    const response = await axios.get(
        getValidatedProductsEndpoint(queryParams)
    );
    return response ? response.data : {};
};

export const getPricesForItemsDataService = async (queryParams) => {
    const response = await axios.get(
        getPricesForItemsEndpoint(queryParams)
    );
    return response ? response.data : {};
};
export const getEquityTemplateDetailsDataService = async (queryParams) => {
    const response = await axios.get(
        getEquityTemplateDetailsEndpoint(queryParams)
    );
    return response ? response.data : {};
};

export const createEquityProductTemplateDataService = async (queryParams) => {
    const response = await axios.post(
        createEquityProductTemplateEndpoint,
        queryParams
    );
    return response ? response.data : {};
};

export const updateEquityProductTemplateDataService = async (queryParams) => {
    const response = await axios.put(
        updateEquityProductTemplateEndpoint,
        queryParams
    );
    return response ? response.data : {};
};

export const getDataForEquityTemplateDataService = async (myCaseRef, orderType) => {
    const response = await axios.get(
        getDataForEquityTemplateEndpoint(myCaseRef, orderType)
    );
    return response ? response.data : {};
};

export const getProductsTemplatesFilterDataService = async () => {
    const response = await axios.get('productsTemplatesFilter');
    return response ? response.data : {};
};

export const getDropdownOptionsFunc = async (dropdownType) => {
    const dropdownEndpoint = getDropdownEnpoint(dropdownType);
    const response = await axios.get(dropdownEndpoint);
    return response ? response.data : {};
};
